import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Station } from "../../../data/models/product/ProductModel";

interface StationListProps {
  stations: Station[];
  deleteStation: (id: string) => Promise<void>;
}

export default function StationsList({
  stations,
  deleteStation,
}: StationListProps) {
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const handleDelete = async (id: string) => {
    setLoadingId(id);
    await deleteStation(id);
    setLoadingId(null);
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 1,
        height: "100%",
        border: "1px solid",
        borderColor: "divider",
        mt: 1,
      }}
    >
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Pantallas
        </Typography>

        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            pr: 0.5,
          }}
        >
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {stations.map((st) => (
              <Chip
                key={st.id}
                label={st.name}
                // onDelete={async () => handleDelete(st.id!)}
                // deleteIcon={
                //   loadingId === st.id ? (
                //     <CircularProgress size={16} />
                //   ) : (
                //     <IconButton
                //       size="small"
                //       sx={{
                //         "& svg": { fontSize: 16 },
                //       }}
                //     >
                //       <DeleteIcon />
                //     </IconButton>
                //   )
                // }
                sx={{
                  borderRadius: 999,
                  px: 1,
                  "& .MuiChip-label": { px: 1 },
                  opacity: loadingId === st.id ? 0.6 : 1,
                }}
                variant="outlined"
                disabled={loadingId !== null}
              />
            ))}
            {stations.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                Aún no tienes pantallas creadas.
              </Typography>
            )}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}
